import { embedFilter } from '../sharedFilters'

const DATASET_KEY = 'security_managment_facility'

export default {
  key: DATASET_KEY,
  label: 'GSMS - Facility',
  timeColumn: 'security_managment_facility.created_at',
  permission: { action: 'reporting', subject: 'Widget' },

  tables: {
    security_managment_facility: ["id", "facility_id", "csis_building_status", "crs_building_status", "region", "country", "state", "city", "zip", "address", "building_code", "facility_name", "floor_code", "occupied", "has_data_center", "has_child_care", "number_of_floors", "occupied_floors", "owned_or_leased", "vacancy_date", "headcount", "updated_headcount", "primary_facility_type", "source_instance", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'security_managment_facility.state',
  },

  csvConfig: {
    withTables: 'security_managment_facility',
    columns: '',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'security_managment_facility.building_code', label: 'Codigo de instalacion' },
    { key: 'security_managment_facility.facility_name', label: 'Nombre' },
    { key: 'security_managment_facility.address', label: 'Direccion' },
    { key: 'security_managment_facility.city', label: 'Ciudad' },
    { key: 'security_managment_facility.state', label: 'Estado' },
    { key: 'security_managment_facility.country', label: 'Pais' },
    { key: 'security_managment_facility.zip_code', label: 'Codigo postal' },
    { key: 'security_managment_facility.primary_facility_type', label: 'Tipo' },
    { key: 'security_managment_facility.crs_building_status', label: 'Estatus CRS' },
    { key: 'security_managment_facility.csis_building_status', label: 'Estatus CSIS' },
    { key: 'security_managment_facility.risk_rating', label: 'Nivel de riesgo' },
    { key: 'security_managment_facility.created_at', label: 'Fecha de creacion', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    embedFilter(DATASET_KEY, 'security_managment_facility.building_code', 'Instalacion', 'installation'),
    embedFilter(DATASET_KEY, 'security_managment_facility.crs_building_status', 'Estatus CRS', 'status'),
    embedFilter(DATASET_KEY, 'security_managment_facility.facility_name', 'Nombre', 'name'),
    embedFilter(DATASET_KEY, 'security_managment_facility.state', 'Estado', 'group'),
    embedFilter(DATASET_KEY, 'security_managment_facility.facility_id', 'ID Instalacion', 'reference'),
    embedFilter(DATASET_KEY, 'security_managment_facility.primary_facility_type', 'Tipo', 'type'),
    embedFilter(DATASET_KEY, 'security_managment_facility.csis_building_status', 'Estatus CSIS', 'level'),
    embedFilter(DATASET_KEY, 'security_managment_facility.city', 'Ciudad', 'city'),
    embedFilter(DATASET_KEY, 'security_managment_facility.country', 'Pais', 'country'),
    embedFilter(DATASET_KEY, 'security_managment_facility.zip_code', 'Codigo postal', 'zip_code'),
    embedFilter(DATASET_KEY, 'security_managment_facility.risk_rating', 'Nivel de riesgo', 'risk_rating'),
  ],

  dateGrouping: {
    column: 'security_managment_facility.created_at',
    presets: [
      { value: '1d', label: 'Dia' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Anio' },
    ],
  },
}
